import { RootState } from '../../../store/appStore';
import { changeTheme } from '../../../store/slices/configSlice';
import { DARK_THEME, LIGHT_THEME } from '../../../utils/constants';
import { useAppDispatch, useAppSelector } from '../../../utils/hooks';

const Toggle = () => {
  const theme = useAppSelector((store: RootState) => store.config.theme);
  const dispatch = useAppDispatch();
  const handleThemeChange = () => {
    dispatch(changeTheme(theme === DARK_THEME ? LIGHT_THEME : DARK_THEME));
  };
  return (
    <button
      data-testid='toggle'
      aria-label='theme button'
      type='button'
      className='mode lg:ml-4'
      onClick={handleThemeChange}
    />
  );
};

export default Toggle;
